import { Button, Menu, MenuHandler, MenuItem, MenuList, Spinner } from "@material-tailwind/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowAccordionIcon from "../../images/icons/ArrowAccordionIcon";

type propTypes = {
    text?: any,
    className?: string,
    handleDownloadPng?: any,
    handleDownloadExcel?: any,
    disabled?: boolean
}
export const ImageDownloadButton = (props: propTypes) => {

    const { text, className = '', handleDownloadPng, handleDownloadExcel, disabled } = props
    const { t } = useTranslation()

    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const textBtn = text ? text : t('consumption.download_excel')

    return (
        <Menu
            dismiss={{
                itemPress: false,
            }}
            placement="bottom"
            open={open}
            handler={(e) => {
                setOpen(e)
            }}
        >
            <MenuHandler>
                <Button
                    color='black'
                    disabled={disabled}
                    className={`w-full tab:w-auto text-[12px] mob:text-[14px] tab:text-[16px] ${className}`}
                >
                    <span className="flex justify-center items-center gap-[8px]">
                        {textBtn}
                        {
                            isLoading ?
                                <Spinner className="w-[1rem]" />
                                :
                                <span className="rotate-[180deg]"><ArrowAccordionIcon className="fill-white h-[8px]" /></span>
                        }
                    </span>
                </Button>
            </MenuHandler>
            <MenuList className=''>
                {
                    handleDownloadPng &&
                    <MenuItem
                        onClick={() => {
                            handleDownloadPng()
                            setOpen(false)
                        }}
                        className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700 `}
                    >
                        {t('analytics.download_image')}
                    </MenuItem>
                }
                {
                    handleDownloadExcel &&
                    <MenuItem
                        onClick={() => {
                            handleDownloadExcel(() => {
                                setIsLoading(false)
                            })
                            setOpen(false)
                            setIsLoading(true)
                        }}
                        className={`flex items-center gap-[6px] py-[10px] px-[16px] text-gray-700 `}
                    >
                        {t('analytics.download_excel')}
                    </MenuItem>
                }
            </MenuList>
        </Menu>
    )
}